import "./ServiceAreas.module.css";
import Header from "@/reusable_sections/Header";
import ServiceAreasHeader from "./sections/ServiceAreasHeader";
import ServiceAreas from "./sections/ServiceAreas";
import RelatedLinksEstimateForm from "./sections/RelatedLinksEstimateForm";
import MarketOverview from "./sections/MarketOverview";
import Footer from "@/reusable_sections/Footer";
export default function ServiceAreasPage() {
  return <div>
      <Header />
      <ServiceAreasHeader />
      <ServiceAreas />
      <MarketOverview />
      <RelatedLinksEstimateForm />
      <Footer />
    </div>;
}